// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"ConsolidatedStockPage_inputContainer__dxd2v"};